import { State } from "../state"
import { isBot } from "@nosto/search-js/utils"

/**
 * Selector returning the state of initialization.
 *
 * Includes special case for bot clients (SEO crawlers).
 * For bots, if the app is in a loading state this selector returns `initialized: false`.
 *
 * The expected use-case is to skip rendering loading state for bots and encourage them to take
 * snapshot of the native products in case Nosto products haven't loaded yet.
 */
export function selectorLoaded({ initialized, loading }: State) {
    return { initialized: isBot() ? initialized && !loading : initialized }
}
